import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';
import { PatientRiskGapsV0 } from './patient-risk-gaps-v0';
import { PatientRiskGapsV1 } from './patient-risk-gaps-v1';

/**
 * Selector component that loads either patient-risk-gaps-v0 or patient-risk-gaps-v1
 * based on the ui-riskcapture-workflow-preview feature flag.
 */
export const PatientRiskGapsUiSelector = () => {
  const riskCaptureWorkflowPreviewEnabled = useFeatureFlag('ui-riskcapture-workflow-preview');

  if (riskCaptureWorkflowPreviewEnabled) {
    return <PatientRiskGapsV1 testId="patient-risk-gaps-v1" />;
  }

  return <PatientRiskGapsV0 testId="resource-table" />;
};
